const zhCN = {
  common: {
    login: '登录',
    register: '免费注册',
    backHome: '返回首页',
    user: '用户',
    admin: '管理员',
    userMenu: '用户菜单',
    logout: '退出登录',
    cancel: '取消',
    delete: '删除',
    loading: '加载中…',
    unknownError: '未知错误',
    emptyValue: '—',
    duration: {
      seconds: '{{value}} 秒',
      minutes: '{{value}} 分钟',
      hours: '{{value}} 小时',
      hoursMinutes: '{{hours}} 小时 {{minutes}} 分钟',
    },
    footerCta: '项目开源，欢迎贡献代码',
    repoLink: '项目地址',
    author: '维护者',
    reload: '重新加载页面',
    loadFailedTitle: '页面加载失败',
    loadFailedBody: '这个页面没能正常渲染，重新加载通常可以解决。',
    openDrawer: '打开导航',
    togglePasswordVisibility: '切换密码可见性',
  },
  language: {
    label: '语言',
    en: 'EN',
    zhCN: '中文',
  },
  navigation: {
    groups: {
      monitor: '监控',
      settings: '设置',
      admin: '管理',
    },
    dashboard: '仪表板',
    tasks: '监控任务',
    publicTasks: '公开任务',
    mySubscriptions: '我的订阅',
    logs: '监控日志',
    emailConfig: '邮件通知',
    blacklist: '域名黑名单',
    users: '用户管理',
  },
  shell: {
    lastCheck: '上次检查 {{time}}',
    noChecks: '暂无检查记录',
  },
  home: {
    navDocs: '文档',
    navLogin: '登录',
    navRegister: '免费注册',
    heroTitleLine1: '网页文字一变',
    heroTitleLine2: '邮件就到',
    heroSubtitle: '用 XPath 选定一块区域，设定检查间隔；区域里的文字一变，就收到邮件。',
    heroPrimary: '开始监控',
    heroSecondary: '登录',
    heroFacts: 'XPath 选区 · Chromium 渲染 · SMTP 发送',
    preview: {
      taskName: '研究生院通知',
      url: 'gs.example.edu/notices',
      interval: '每 5 分钟',
      checkedLabel: '上次检查',
      checkedValue: '3 分钟前',
      recipientLabel: '通知对象',
      recipientValue: 'admin@example.edu',
      changeLabel: '检测到变化',
      changeTime: '09:41',
      lineOld: '2027 春季招生公告已发布',
      lineNew: '申请通道 1 月 12 日开放',
      emailLabel: '通知',
      emailValue: '已发送至 admin@example.edu',
    },
    license: 'CC BY-NC 4.0 许可',
    featuresTitle: '配置检查，查看变化',
    featuresSubtitle: '选定页面区域和检查间隔，在日志中核对采集结果，并通过邮件接收变化提醒。',
    features: [
      {
        key: 'realtime',
        title: 'JavaScript 渲染页面',
        description: 'Chromium 加载页面后读取选定文字，支持由 JavaScript 渲染的内容。',
      },
      {
        key: 'notifications',
        title: '变化邮件',
        description: '配置自己的邮件账户，在检查发现文字变化时接收通知。',
      },
      {
        key: 'secure',
        title: '账户访问',
        description: '登录后管理自己的监控任务和邮件设置。',
      },
      {
        key: 'performance',
        title: '采集日志',
        description: '查看检查时间、提取文字和采集错误。',
      },
      {
        key: 'analysis',
        title: 'XPath 选区',
        description: '用 XPath 表达式选定需要对比的页面区域。',
      },
      {
        key: 'schedule',
        title: '独立检查间隔',
        description: '为每个任务设置检查目标页面的时间间隔。',
      },
    ],
    advantagesTitle: '管理任务与订阅',
    advantages: [
      {
        key: 'setup',
        title: '浏览器内配置',
        description: '在应用里填写网址、XPath 和检查间隔。',
      },
      {
        key: 'scale',
        title: '公开任务订阅',
        description: '订阅实例内的公开任务，并管理自己的订阅。',
      },
      {
        key: 'api',
        title: 'HTTP API',
        description: '通过需要身份认证的 API 管理任务、读取采集日志。',
      },
    ],
    ctaTitle: '立即开始监控您关心的网页内容',
    ctaSubtitle: '创建任务，设置检查间隔，再配置邮件以接收变化通知。',
    footerTagline: '按时检查网页，用 XPath 选区，通过邮件接收变化提醒',
  },
  login: {
    heroTitle: '按计划检查，变化时通知',
    heroSubtitle: '登录后管理监控任务、查看采集日志并配置邮件通知。',
    facts: '定时检查 · 采集文字 · 变化邮件',
    formTitle: '登录',
    formSubtitle: '输入账户信息',
    username: '用户名',
    password: '密码',
    submit: '登录',
    submitting: '登录中…',
    noAccount: '还没有账户？',
    registerNow: '立即创建',
    defaultError: '登录失败，请检查用户名和密码',
  },
  register: {
    heroTitleStart: '创建您的',
    heroTitleAccent: '监控账户',
    heroSubtitle: '账号保存你的监控任务、订阅和邮件设置。',
    benefitsTitle: '账号包含',
    benefits: ['定时检查页面', '邮件变化通知', '自定义检查间隔', 'XPath 文字选区'],
    formTitle: '创建账户',
    formSubtitle: '设置用户名、邮箱和密码',
    username: '用户名',
    email: '邮箱地址',
    password: '密码',
    confirmPassword: '确认密码',
    passwordStrength: '密码强度',
    weak: '弱',
    medium: '中等',
    strong: '强',
    submitting: '正在创建账户…',
    submit: '创建账户',
    existingAccount: '已有账户？',
    loginNow: '立即登录',
    instanceNote: '账户仅属于当前 WebMonitor 实例。',
    validation: {
      required: '请填写所有必填字段',
      username: '用户名长度至少为3位',
      mismatch: '两次输入的密码不一致',
      password: '密码长度至少为6位',
      email: '请输入有效的邮箱地址',
      success: '注册成功，正在跳转到登录页。',
      failed: '注册失败，请稍后重试',
    },
  },
  dashboard: {
    title: '仪表板',
    subtitle: '实时监控您的网页内容变化',
    refresh: '刷新数据',
    totalTasks: '总任务数',
    activeTasks: '活跃任务',
    recentChanges: '最近变化',
    successRate: '成功率',
    allTasks: '当前任务列表中的任务数',
    runningTasks: '当前启用中的任务数',
    detectedChanges: '最近 {{sample}} 条日志中的内容变化数',
    executionSuccessRate: '最近 {{sample}} 条日志中的执行成功占比',
    noSamples: '暂无日志样本',
    recentActivity: '最近监控活动',
    viewAll: '查看全部',
    noActivity: '暂无监控活动',
    noActivitySubtitle: '开始创建监控任务后，这里将显示活动记录',
    taskLabel: '任务',
    changed: '内容变化',
    unchanged: '无变化',
    errorPrefix: '错误',
    changeDetected: '检测到内容变化',
    newContentPreview: '新内容预览',
    contentUnchanged: '内容未发生变化',
    quickActions: '快速操作',
    checksByTask: '按任务检查',
    checkCount: '检查',
    changeCount: '变化',
    recentErrors: '最近的错误',
    manageTasks: '管理监控任务',
    configureEmail: '配置邮件通知',
    viewLogs: '查看详细日志',
  },
  tasks: {
    title: '监控任务管理',
    subtitle: '管理和配置您的网页监控任务',
    createTask: '创建新任务',
    blacklistTitle: '黑名单限制说明',
    blacklistItem1: '普通用户无法监控黑名单中禁止的网站域名',
    blacklistItem2: '如需监控被限制的网站，请联系管理员将域名从黑名单中移除',
    blacklistItem3: '管理员可访问“黑名单管理”功能进行域名管理',
    totalTasks: '总任务数',
    activeTasks: '活跃任务',
    pausedTasks: '暂停任务',
    emailNotifications: '邮件通知',
    taskList: '监控任务列表',
    noTasks: '暂无监控任务',
    noTasksSubtitle: '创建您的第一个监控任务开始监控网页内容变化',
    createFirstTask: '创建第一个任务',
    taskInfo: '任务信息',
    monitorConfig: '监控配置',
    interval: '检查间隔',
    emailConfig: '邮件配置',
    status: '状态',
    actions: '操作',
    notSet: '未设置',
    unknownConfig: '未知配置',
    running: '运行中',
    paused: '已暂停',
    testMonitor: '测试监控',
    editTask: '编辑任务',
    deleteTask: '删除任务',
    editDialogTitle: '编辑监控任务',
    createDialogTitle: '创建新监控任务',
    taskName: '任务名称',
    monitorUrl: '监控 URL',
    xpathSelector: 'XPath 选择器',
    xpathHelper: '用于定位监控内容的 XPath 表达式',
    intervalSeconds: '检查间隔（秒）',
    emailConfigNone: '不发送通知',
    emailConfigHelper: '保持“不发送通知”时，任务照常采集并记录日志，只是不发邮件。',
    addEmailConfigHint: '还没有邮件配置——任务仍会采集并记录日志，但无法通知任何人。',
    taskDescription: '任务描述',
    taskDescriptionHelper: '可选的任务描述，公开任务时其他用户可以看到此描述',
    publicTask: '公开任务',
    publicTaskHelper: '公开后其他用户可以订阅此任务并收到变更通知',
    enableMonitoring: '启用监控',
    enableMonitoringHelper: '立即开始监控指定网页',
    updateTask: '更新任务',
    submitCreateTask: '创建任务',
    loadTasksError: '加载监控任务失败',
    deleteConfirmTitle: '删除监控任务',
    deleteConfirm: '确定要删除这个监控任务吗？',
    testSuccess: '测试成功！',
    contentLabel: '内容',
    testFailed: '测试失败',
    blacklistAlertTitle: '黑名单限制',
    createFailed: '创建监控任务失败',
    updateFailed: '更新监控任务失败',
    deleteSuccess: '监控任务已删除',
    deleteFailed: '删除监控任务失败',
    created: '监控任务已创建',
    updated: '监控任务已更新',
  },
  logs: {
    title: '监控日志',
    subtitle: '查看和分析监控任务的执行记录',
    selectTask: '选择监控任务',
    loadError: '加载监控日志失败',
    totalLogs: '总日志数',
    unchanged: '无变化',
    changed: '内容变化',
    error: '错误',
    tableTitle: '监控日志记录',
    checkTime: '检查时间',
    status: '状态',
    newContent: '新内容',
    errorInfo: '错误信息',
    noLogs: '暂无监控日志',
    noLogsSubtitle: '该任务还没有执行过监控',
    paginationSummary: '显示第 {{start}}–{{end}} 条，共 {{total}} 条记录',
    emptySummary: '0–0 / {{total}}',
    rowsPerPage: '每页显示',
    selectTaskEmpty: '请选择监控任务',
    selectTaskSubtitle: '选择一个监控任务查看其执行日志',
    noTasks: '您还没有监控任务，创建任务后即可查看日志。',
  },
  emailConfig: {
    sslConfigs: 'SSL 加密',
    receiverAddresses: '接收地址',
    title: '邮件配置',
    subtitle: '配置用于发送通知的 SMTP 服务器与收件人',
    addConfig: '添加邮件配置',
    emailConfigs: '邮件配置',
    sectionTitle: 'SMTP 邮件配置',
    sectionDescription:
      '配置 SMTP 邮件服务器，系统将在监控到内容变化时发送通知邮件。支持多个邮件配置，在创建监控任务时可以选择使用哪个配置。',
    noConfigs: '暂无邮件配置',
    noConfigsSubtitle: '添加第一个邮件配置开始使用通知功能',
    createFirstConfig: '创建第一个配置',
    configDetails: '配置详情',
    senderEmail: '发送邮箱',
    receiverEmail: '接收邮箱',
    actions: '操作',
    smtpSenderAccount: 'SMTP 发送账户',
    notificationReceiver: '通知接收账户',
    testConnection: '测试连接',
    editConfig: '编辑配置',
    deleteConfig: '删除配置',
    operationFailed: '操作失败',
    editDialogTitle: '编辑邮件配置',
    createDialogTitle: '创建邮件配置',
    dialogSubtitle: '配置 SMTP 邮件服务器发送通知',
    configName: '配置名称',
    smtpServer: 'SMTP 服务器',
    smtpPort: 'SMTP 端口',
    senderAddress: '发件人邮箱',
    smtpPassword: 'SMTP 密码',
    passwordHelper: '建议使用应用专用密码以提高安全性',
    passwordHelperEdit: '留空则保持原密码不变',
    receiverAddress: '接收者邮箱',
    useSsl: '使用 SSL 加密',
    useSslHelper: '启用 SSL/TLS 加密连接确保邮件传输安全',
    cancel: '取消',
    updateConfig: '更新配置',
    createConfig: '创建配置',
    loadFailed: '加载邮件配置失败',
    createSuccess: '邮件配置已创建',
    updateSuccess: '邮件配置已更新',
    deleteSuccess: '邮件配置已删除',
    deleteFailed: '删除邮件配置失败',
    deleteConfirmTitle: '删除邮件配置',
    deleteConfirm: '确定要删除这个邮件配置吗？',
    testSuccess: '测试邮件发送成功',
    testFailed: '测试邮件发送失败',
  },
  users: {
    disabledUsers: '已停用',
    title: '用户管理',
    subtitle: '管理系统用户账户和权限',
    createUser: '创建新用户',
    totalUsers: '总用户数',
    activeUsers: '活跃用户',
    admins: '管理员',
    listTitle: '用户列表',
    guideText: '管理员可以创建、编辑和删除用户账户。注意：不能删除自己的账户。',
    noUsers: '暂无用户',
    noUsersSubtitle: '创建第一个用户开始使用系统',
    createFirstUser: '创建第一个用户',
    userInfo: '用户信息',
    emailAddress: '邮箱地址',
    rolePermission: '角色权限',
    subscriptionLimit: '订阅限制',
    accountStatus: '账户状态',
    actions: '操作',
    fullNameNotSet: '未设置全名',
    admin: '管理员',
    regularUser: '普通用户',
    subscriptionUnit: '个',
    enabled: '启用',
    disabled: '禁用',
    editUser: '编辑用户',
    deleteUser: '删除用户',
    deleteConfirmTitle: '删除用户',
    deleteConfirm: '确定要删除这个用户吗？',
    loadFailed: '加载用户列表失败',
    editDialogTitle: '编辑用户',
    createDialogTitle: '创建新用户',
    editDialogSubtitle: '修改用户信息和权限',
    createDialogSubtitle: '添加新的系统用户',
    username: '用户名',
    fullName: '全名',
    password: '密码',
    passwordHelperEdit: '留空则不修改密码',
    passwordHelperCreate: '请设置安全密码',
    maxSubscriptions: '最大订阅数量',
    maxSubscriptionsHelper: '该用户最多可以订阅的公开任务数量',
    adminPermission: '管理员权限',
    adminPermissionHelper: '拥有系统管理权限',
    activeAccount: '启用账户',
    activeAccountHelper: '允许用户登录系统',
    updateUser: '更新用户',
    createUserAction: '创建用户',
    createSuccess: '用户已创建',
    updateSuccess: '用户已更新',
    deleteSuccess: '用户已删除',
    cannotDeleteSelf: '不能删除自己的账户',
  },
  blacklist: {
    exactDomains: '精确域名',
    partialDomains: '部分匹配',
    title: '黑名单管理',
    subtitle: '管理禁止普通用户监控的网站域名',
    addDomain: '添加域名',
    totalDomains: '总域名数',
    wildcardDomains: '通配符域名',
    guideTitle: '功能说明',
    guideLine1: '普通用户无法监控黑名单中的域名',
    guideLine2: '管理员可以监控任何网站，包括黑名单中的域名',
    guideLine3: '黑名单支持通配符匹配（如 *.example.com 会阻止所有子域名）',
    guideLine4: '支持部分匹配（如 example 会阻止包含 example 的所有域名）',
    listTitle: '黑名单域名列表',
    noDomains: '暂无黑名单域名',
    noDomainsSubtitle: '添加需要禁止普通用户监控的域名',
    addFirstDomain: '添加第一个域名',
    domain: '域名',
    description: '描述',
    status: '状态',
    createdAt: '创建时间',
    actions: '操作',
    wildcard: '通配符域名',
    enabled: '启用',
    disabledLabel: '禁用',
    edit: '编辑',
    delete: '删除',
    editDialogTitle: '编辑黑名单域名',
    createDialogTitle: '添加黑名单域名',
    domainPlaceholder: '例如: example.com, *.example.com, example',
    descriptionPlaceholder: '可选的域名描述信息',
    enabledStatus: '启用状态',
    update: '更新',
    create: '添加',
    fetchFailed: '获取黑名单失败',
    updateSuccess: '黑名单更新成功',
    createSuccess: '黑名单添加成功',
    deleteConfirmTitle: '删除黑名单域名',
    deleteConfirm: '确定要删除这个黑名单域名吗？',
    deleteSuccess: '黑名单删除成功',
  },
  publicTasks: {
    title: '公开任务市场',
    subtitle: '发现和订阅其他用户分享的监控任务',
    publicTasks: '公开任务',
    mySubscriptions: '我的订阅',
    remainingSlots: '剩余额度',
    totalSubscriptions: '总订阅数',
    usageLine3: '订阅任务后，当任务监控到内容变化时，您会收到邮件通知',
    taskList: '公开任务列表',
    noTasks: '暂无公开任务',
    noTasksSubtitle: '当前没有用户分享公开的监控任务',
    taskInfo: '任务信息',
    creator: '创建者',
    subscriptions: '订阅数',
    interval: '检查间隔',
    createdAt: '创建时间',
    actions: '操作',
    subscribe: '订阅',
    unsubscribe: '取消订阅',
    subscribeTask: '订阅任务',
    unsubscribeTask: '取消订阅',
    viewDetails: '查看详情',
    taskDetails: '任务详情',
    noDescription: '暂无描述',
    monitorUrl: '监控 URL',
    subscriberCount: '订阅人数',
    close: '关闭',
    chooseEmailConfig: '选择邮箱配置',
    chooseEmailConfigSubtitle: '订阅任务需要配置邮件通知，请选择要使用的邮箱配置',
    noEmailConfig: '您还没有配置邮箱通知设置。请先在“邮件通知配置”页面添加邮箱配置后再订阅任务。',
    emailConfig: '邮箱配置',
    cancel: '取消',
    confirmSubscribe: '确认订阅',
    toggleFailed: '操作失败',
    subscribeWithEmailFailed: '使用该邮箱配置订阅失败',
    subscribed: '订阅成功',
    unsubscribed: '已取消订阅',
    createdByLabel: '创建者',
    createdAtLabel: '创建时间',
    loadFailed: '加载任务市场失败',
  },
  subscriptions: {
    taskUnavailable: '任务已不再公开或已停用',
    title: '我的订阅',
    subtitle: '管理您订阅的公开任务和通知设置',
    totalSubscriptions: '总订阅数',
    notificationsEnabled: '启用通知',
    notificationsDisabled: '停用通知',
    emailConfigs: '邮箱配置',
    guideLine1: '启用通知后，当订阅的任务内容发生变化时将收到邮件通知',
    guideLine2: '可以为每个订阅单独配置邮箱通知设置',
    guideLine3: '停用通知后将不再收到邮件，但订阅记录会保留',
    listTitle: '我的订阅列表',
    noSubscriptions: '暂无订阅任务',
    noSubscriptionsSubtitle: '前往“公开任务市场”订阅感兴趣的任务',
    browsePublicTasks: '浏览公开任务',
    taskInfo: '任务信息',
    taskUrl: '任务 URL',
    owner: '任务所有者',
    emailConfig: '邮箱配置',
    subscribedAt: '订阅时间',
    actions: '操作',
    unknownConfig: '未知配置',
    defaultConfig: '默认配置',
    editSubscription: '编辑订阅',
    deleteSubscription: '取消订阅',
    editDialogTitle: '编辑订阅设置',
    taskLabel: '任务',
    enableEmailNotifications: '启用邮件通知',
    emailConfigLabel: '邮箱配置',
    useDefaultConfig: '使用默认配置',
    cancel: '取消',
    saveSettings: '保存设置',
    updateSuccess: '订阅更新成功',
    updateFailed: '更新订阅失败',
    deleteConfirmTitle: '取消订阅',
    deleteConfirm: '确定要取消这个订阅吗？',
    deleteSuccess: '订阅取消成功',
    deleteFailed: '取消订阅失败',
    loadFailed: '加载订阅失败',
  },
  documentation: {
    badge: '文档',
    openNavigation: '文档目录',
    contents: '目录',
  },
};

export default zhCN;
